import React from "react";
import "../App.css";

function PrivacyPolicyPage() {
  return (
    <div
      className="privacy-page"
      style={{
        padding: "4rem 2rem",
        maxWidth: "1000px",
        margin: "0 auto",
        lineHeight: "1.8",
      }}
    >
      <h1 style={{ marginBottom: "2rem" }}>Datenschutz</h1>
      <p>
        Wir nehmen den Schutz deiner persönlichen Daten ernst. Auf dieser Seite
        informierst du dich über die Verarbeitung personenbezogener Daten bei
        der Nutzung von Onenizer.
      </p>
    </div>
  );
}

export default PrivacyPolicyPage;
